/**
 * @generated SignedSource<<98228b90233c1c3061f724d42127c140>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AttachmentKind = "DefaultFile";
import { FragmentRefs } from "relay-runtime";
export type AttachmentEditor_TreeNodeFragment$data = {
  readonly attachments: ReadonlyArray<{
    readonly description?: string | null;
    readonly file?: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id?: string;
    readonly kind: AttachmentKind;
    readonly title?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"DefaultFileAttachmentForm_AttachmentV2Fragment">;
  }>;
  readonly id: string;
  readonly " $fragmentType": "AttachmentEditor_TreeNodeFragment";
};
export type AttachmentEditor_TreeNodeFragment$key = {
  readonly " $data"?: AttachmentEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentEditor_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentEditor_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "file",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "type": "DefaultFileAttachment",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DefaultFileAttachmentForm_AttachmentV2Fragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "8aaa3f2b264c3993768e8de586490d09";

export default node;
